import * as Yup from 'yup';
import * as utils from './StrUtils.js';

const RSEmail = ({qObj}) => {
  let valObj = Yup.string();

  valObj = utils.setRequired(valObj, qObj);

  valObj = utils.setAsEmail(valObj, qObj, true);
  return valObj;
};

export default RSEmail;